import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  messagesContainer: {
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(1),
    backgroundColor: '#f5f5f5',
    paddingBottom: theme.spacing(8),
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[400],
      borderRadius: '3px',
    },
  },
  messageItem: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: theme.spacing(1, 0.5),
    borderRadius: theme.spacing(1),
    backgroundColor: '#f5f5f5',
    marginBottom: theme.spacing(0),
    overflow: 'hidden',
    alignSelf: 'flex-start',
    '&.user': {
      alignSelf: 'flex-end',
      '& $messageBubble': {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        borderTopRightRadius: theme.spacing(0.5),
      },
    },
    '&.menuOpen': {
      '& $messageBubble $messageActions': {
        top: '0px !important',
      },
    },
    '&:hover $messageBubble $messageActions': {
      top: 0,
    },
  },
  messageBubble: {
    backgroundColor: '#f5f5f5',
    wordBreak: 'break-word',
  },
  messageMeta: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
  },
  avatar: {
    marginInline: theme.spacing(0.5),
    marginTop: 0,
    alignSelf: 'flex-end',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    height: theme.spacing(5.6),
    width: theme.spacing(5.6),
    fontSize: '0.875rem',
    borderRadius: theme.spacing(0.8),
  },
  messageActions: {
    position: 'absolute',
    top: -50,
    right: 0,
    display: 'flex',
    backgroundColor: '#f5f5f5',
    borderRadius: theme.spacing(2),
    transition: 'all 0.3s ease',
  },

  menuItem: {
    minHeight: '32px',
    padding: '4px 12px',
    fontSize: '0.8125rem',
  },
  listItemIcon: {
    minWidth: '36px',
    '& svg': {
      fontSize: '18px',
    },
  },
  listItemText: {
    '& .MuiTypography-root': {
      fontSize: '0.8125rem',
    },
  },

  filesPreviewContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
  },
  fileThumbnail: {
    width: 60,
    height: 60,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: theme.palette.grey[100],
    '&:hover $fileRemoveButton': {
      opacity: 1,
    },
  },
  fileDocument: {
    width: 60,
    height: 60,
    backgroundColor: theme.palette.grey[400],
    borderRadius: theme.shape.borderRadius,
    '& .MuiSvgIcon-root': {
      fontSize: '2.5rem',
    },
  },
  fileImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}));

export default useStyles;
